export enum ORIGIN_TYPES {
	LIVE_LINK = 'LIVE_LINK',
	DRIVER_APP = 'DRIVER_APP',
	EMPLOYEE_APP = 'EMPLOYEE_APP',
	INTERNAL_MANAGER = 'INTERNAL_MANAGER',
	RESIDENTIAL_APP = 'RESIDENTIAL_APP',
	BUSINESS_MANAGER = 'BUSINESS_MANAGER',
	MOBO = 'MOBO',
	CRON_JOB = 'CRON_JOB',
	WEBHOOK = 'WEBHOOK',
	LAUNDROWORKS = 'LAUNDROWORKS',
	POCKETFLOWS = 'POCKETFLOWS',
	BOT = 'BOT',
	DUDA_WIDGET = 'DUDA_WIDGET',
	BACKEND = 'BACKEND',
	BARRY = 'BARRY',
	DISPATCH_API = 'DISPATCH_API',
}
